// Indicadores calculados da Rampa de lançamentos (não digitados: saem das contas dos lançamentos mensais).

/** Gramatura em kg a partir do texto do cadastro ("250g", "1 kg", "1,5kg", "90 g"). null se não der para ler. */
export function gramaturaKg(texto: string | null | undefined): number | null {
  const m = /(\d+(?:[.,]\d+)?)\s*(kg|g|gr|ml|l)?/i.exec(texto ?? '');
  if (!m?.[1]) return null;
  const n = Number(m[1].replace(',', '.'));
  if (!Number.isFinite(n) || n <= 0) return null;
  const un = (m[2] ?? '').toLowerCase();
  if (un === 'kg' || un === 'l') return n;
  if (un === 'g' || un === 'gr' || un === 'ml') return n / 1000;
  return n >= 10 ? n / 1000 : n; // sem unidade: 250 → gramas; 1,5 → kg
}

/** Semanas consideradas em um mês (convenção da gestão: 4). */
export const SEMANAS_POR_MES = 4;

/**
 * VENDA EM UNIDADE POR LOJA POR SEMANA = volume (kg) ÷ PCA (lojas) ÷ gramatura (kg) ÷ 4 semanas.
 * null se faltar volume/PCA/gramatura ou se PCA = 0.
 */
export function vendaUnLojaSemana(
  volumeKg: number | null | undefined,
  pca: number | null | undefined,
  gramatura: string | null | undefined,
): number | null {
  const g = gramaturaKg(gramatura);
  if (volumeKg == null || pca == null || pca <= 0 || g == null) return null;
  return volumeKg / pca / g / SEMANAS_POR_MES;
}

export const ROTULO_UN_LOJA_SEMANA = 'Venda (un.) por loja por semana';
export const ROTULO_UN_LOJA_SEMANA_EN = 'Units sold per store per week';
